import * as AT from './actionTypes.js'
import { createAction } from 'redux-actions'

export const userLogInRequest = createAction(AT.USER_LOG_IN_REQUEST, token => {
	return {
		isFetching: true,
		isAuthenticated: false,
		token
	}
})

export const userLogInSuccess = createAction(
	AT.USER_LOG_IN_SUCCESS,
	({ token, firstLogin, loggedInAt }) => {
		return {
			isFetching: false,
			isAuthenticated: true,
			firstLogin,
			token,
			loggedInAt
		}
	}
)

export const userLogInFailure = createAction(
	AT.USER_LOG_IN_FAILURE,
	({ error }) => {
		return {
			isFetching: false,
			isAuthenticated: false
		}
	}
)

export const userLogOutRequest = createAction(AT.USER_LOG_OUT_REQUEST)
export const userLogOutSuccess = createAction(AT.USER_LOG_OUT_SUCCESS)
export const userLogOutFailure = createAction(
	AT.USER_LOG_OUT_FAILURE,
	({ error: { message } }) => {
		return {
			error: message
		}
	}
)

export const userLoadDataRequest = createAction(AT.USER_LOAD_DATA_REQUEST)
export const userLoadDataSuccess = createAction(AT.USER_LOAD_DATA_SUCCESS)
export const userLoadDataFailure = createAction(AT.USER_LOAD_DATA_FAILURE)

export const postsLoadRequest = createAction(AT.POSTS_LOAD_REQUEST)
export const postsLoadSuccess = createAction(AT.POSTS_LOAD_SUCCESS)
export const postsLoadFailure = createAction(AT.POSTS_LOAD_FAILURE)

export const projectsLoadRequest = createAction(AT.PROJECTS_LOAD_REQUEST)
export const projectsLoadSuccess = createAction(AT.PROJECTS_LOAD_SUCCESS)
export const projectsLoadFailure = createAction(AT.PROJECTS_LOAD_FAILURE)

export const appCreateRequest = createAction(AT.APP_CREATE_REQUEST)
export const appCreateSuccess = createAction(AT.APP_CREATE_SUCCESS)
export const appCreateFailure = createAction(
	AT.APP_CREATE_FAILURE,
	({ error: { message } }) => {
		return {
			error: message
		}
	}
)

export const appDeleteRequest = createAction(AT.APP_DELETE_REQUEST)
export const appDeleteSuccess = createAction(AT.APP_DELETE_SUCCESS)
export const appDeleteFailure = createAction(AT.APP_DELETE_FAILURE)

export const appInstallRequest = createAction(AT.APP_INSTALL_REQUEST)
export const appInstallSuccess = createAction(AT.APP_INSTALL_SUCCESS)
export const appInstallFailure = createAction(AT.APP_INSTALL_FAILURE)

export const appPublishRequest = createAction(AT.APP_PUBLISH_REQUEST)
export const appPublishSuccess = createAction(AT.APP_PUBLISH_SUCCESS)
export const appPublishFailure = createAction(AT.APP_PUBLISH_FAILURE)

export const appUnpublishRequest = createAction(AT.APP_UNPUBLISH_REQUEST)
export const appUnpublishSuccess = createAction(AT.APP_UNPUBLISH_SUCCESS)
export const appUnpublishFailure = createAction(AT.APP_UNPUBLISH_FAILURE)

export const appUninstallRequest = createAction(AT.APP_UNINSTALL_REQUEST)
export const appUninstallSuccess = createAction(AT.APP_UNINSTALL_SUCCESS)
export const appUninstallFailure = createAction(AT.APP_UNINSTALL_FAILURE)

export const appUpdateRequest = createAction(AT.APP_UPDATE_REQUEST)
export const appUpdateSuccess = createAction(AT.APP_UPDATE_SUCCESS)
export const appUpdateFailure = createAction(AT.APP_UPDATE_FAILURE)

export const submissionListRequest = createAction(
	AT.SUBMISSION_LIST_REQUEST,
	payload => {
		return {
			isFetching: true,
			...payload
		}
	}
)
export const submissionListSuccess = createAction(
	AT.SUBMISSION_LIST_SUCCESS,
	({ items, receivedAt }) => {
		return {
			isFetching: false,
			items,
			receivedAt
		}
	}
)
export const submissionListFailure = createAction(
	AT.SUBMISSION_LIST_FAILURE,
	({ error: { message } }) => {
		return {
			isFetching: false,
			error: message
		}
	}
)

export const submissionCreateRequest = createAction(
	AT.SUBMISSION_CREATE_REQUEST
)
export const submissionCreateSuccess = createAction(
	AT.SUBMISSION_CREATE_SUCCESS
)
export const submissionCreateFailure = createAction(
	AT.SUBMISSION_CREATE_FAILURE,
	({ error: { message } }) => {
		return {
			error: message
		}
	}
)

export const submissionCancelRequest = createAction(
	AT.SUBMISSION_CANCEL_REQUEST
)
export const submissionCancelSuccess = createAction(
	AT.SUBMISSION_CANCEL_SUCCESS
)
export const submissionCancelFailure = createAction(
	AT.SUBMISSION_CANCEL_FAILURE
)

export const installedAppListRequest = createAction(
	AT.INSTALLED_APP_LIST_REQUEST,
	payload => {
		return {
			isFetching: true
		}
	}
)
export const installedAppListSuccess = createAction(
	AT.INSTALLED_APP_LIST_SUCCESS,
	({ items, receivedAt }) => {
		return {
			isFetching: false,
			items,
			receivedAt
		}
	}
)
export const installedAppListFailure = createAction(
	AT.INSTALLED_APP_LIST_FAILURE,
	({ error: { message } }) => {
		return {
			isFetching: false,
			error: message
		}
	}
)
export const appListRequest = createAction(AT.APP_LIST_REQUEST, payload => {
	return {
		isFetching: true
	}
})
export const appListSuccess = createAction(
	AT.APP_LIST_SUCCESS,
	({ items, receivedAt }) => {
		return {
			isFetching: false,
			items,
			receivedAt
		}
	}
)
export const appListFailure = createAction(
	AT.APP_LIST_FAILURE,
	({ error: { message } }) => {
		return {
			isFetching: false,
			error: message
		}
	}
)

export const fileUploadRequest = createAction(AT.FILE_UPLOAD_REQUEST)
export const fileUploadSuccess = createAction(AT.FILE_UPLOAD_SUCCESS)
export const fileUploadFailure = createAction(AT.FILE_UPLOAD_FAILURE)
export const fileUploadClear = createAction(AT.FILE_UPLOAD_CLEAR)



// WEBPACK FOOTER //
// ./src/actions/index.js